import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

export const Logo = styled('div', {
  shouldForwardProp,
})(() => css({}));
